import React, { Component } from 'react'
import Button from '../../../../v2SPRINTA/atoms/Button'
import { Col, Row, Container } from '../../../../v2SPRINTA/atoms/Grid'
import Loading from '../../../../SPRINTA/atoms/Loading'

import css from './style.css'
import ActionBtnIcon from '../../../../SPRINTA/molecules/ActionBtnIcon'
import ScrollTo, { getPosition } from '../../../../SPRINTA/atoms/ScrollTo'

class Navigationbar extends Component {

    gotoInput(input) {
        let position = getPosition(input)
        ScrollTo(position.y-150)
    }

    render() {
        return (
            <Container style={{ paddingBottom: '70px' }}>
                {this.props.errors && (
                    <Row>
                        <Col size='12 12 4' />
                        <Col size='12 12 8'>
                            <ul className={css.errors}>
                                <li><b>Ops! Encontramos as seguintes pendências!</b></li>
                                {this.props.errors.map((error, k) => (
                                    <li key={`${error.element}${k}`}>
                                        <span className={css.message}>- {error.error}</span>
                                        <span className={css.icon}>
                                            <ActionBtnIcon
                                                icon='search'
                                                theme='danger'
                                                rounded
                                                size={20}
                                                action={() => this.gotoInput(error.element)} />
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </Col>
                    </Row>
                )}
                <Row alignItems="center" justifyContent="end end start">
                    <Col size='12 12 4' />

                    <Col size='6 6 4 3'>
                        <Button primary onClick={ () => this.props.handleNextStep() }>
                            {this.props.loadingDone ? (
                                <Loading color='#fff' />
                            ) : this.props.step === this.props.steps ? this.props.finish : `Próximo passo` }
                        </Button>
                    </Col>
                    
                    <Col size='12 12 4 5' hidden='xs sm'>
                        {this.props.step === this.props.steps
                        ? `Você está no último passo`
                        : `Você está no passo ${this.props.step} de ${this.props.steps} existentes`}
                    </Col>
                </Row>

            </Container>
        )
    }
}
export default Navigationbar


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/NavigationBar/index.js